var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#FEF9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.502 15h7.128A3.375 3.375 0 0 1 27 18.375v9.375a3 3 0 0 0 3-3v-9.642c0-1.505-1.125-2.811-2.664-2.94a49.45 49.45 0 0 0-.673-.05A3 3 0 0 0 24 10.5h-1.5a3 3 0 0 0-2.663 1.618 49.74 49.74 0 0 0-.673.05c-1.502.126-2.61 1.373-2.662 2.832zm5.998-3a1.5 1.5 0 0 0-1.5 1.5h4.5A1.5 1.5 0 0 0 24 12h-1.5z",
    fill: "#F88634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.375c0-1.035.84-1.875 1.875-1.875h9.75c1.035 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 12 29.625v-11.25zm9.586 4.593a.75.75 0 0 0-1.172-.936l-2.476 3.095-.908-.907a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.116-.062l3-3.75z",
    fill: "#F88634"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistNewIcon);
export default __webpack_public_path__ + "static/media/checklist-new-icon.9ba7ce6758d6729cde1428575438738b.svg";
export { ForwardRef as ReactComponent };